import { Card, Col, Progress, Row, Tag } from 'antd';
import React, { useState } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import ButtonLink from 'components/theme_components/ButtonLink';
import DataGrid from 'components/theme_components/DataGrid';
import DualPieChart from 'components/theme_components/PieChart';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ProgressBarChart from 'components/theme_components/ProgressBarChart';
import StatCard from 'components/theme_components/StatCard';
import Title from 'components/Title';

export type DashboardProps = {
  form?: FormInstance;
  color?: string;
  onSave?: (values: any) => void;
  onEdit?: () => void;
};

const Dashboard = ({form,color,onSave,onEdit}: DashboardProps) => {
  const columns = [
    {
      dataIndex: 'propreference',
      width: '10%',
    },
    {
      dataIndex: 'ctreference',
      width: '10%',
    },

    {
      dataIndex: 'prcode',
      width: '10%',
    },
    {
      comcode: 'offeridlabel',
      dataIndex: 'offerid',
      width: '10%',
    },
    {
      dataIndex: 'clientname',
      width: '10%',
    },
  ];

  return (
    <div className="bg-color-gray">
      <div className="ut-title-page no-after globalvision">
        <Row justify="space-between" gutter={16} align="middle">
          <Col span={24}>
            {/* The stat cards should be fetched from the API (which are not implemented yet) */}
            <StatCard
              title=""
              value="Les exclusions se sont au niveau intra-marque"
              variant="notif"
              className="mb-8 staticNotf mt-8"
              valueStyle={{
                backgroundColor: '#F7C0A929',
              }}
              width="98.5%"
            />
          </Col>
          <Col span={4}>
            <StatCard
              title="Nb. Agios"
              value="N/A"
              variant="secondary"
              width="90%"
              statisticProps={{
                suffix: (
                  <small className="gray-color staticCard-small-1 staticCard-small">
                    (N/A K)
                  </small>
                ),
              }}
            />
          </Col>
          <Col span={4}>
            <StatCard
              title="Nb. paiements programmés"
              value={'N/A'}
              variant="green"
              width="90%"
              height="126px"
              statisticProps={{
                suffix: (
                  <small className="gray-color staticCard-small">(N/A €)</small>
                ),
              }}
            />
          </Col>
          <Col span={4}>
            <StatCard
              title={'Nb. châssis en  \n \n  ' + 'franchise'}
              value={'N/A'}
              variant="warning"
              width="90%"
              height="126px"
            />
          </Col>
          <Col span={4}>
            <StatCard
              title={'Nb. châssis en taux 1 \n \n '}
              value={'N/A'}
              variant="primary"
              width="90%"
              height="126px"
            />
          </Col>
          <Col span={4}>
            <StatCard
              title="Nb. châssis en taux 2"
              value={'N/A'}
              variant="warning"
              width="90%"
              height="126px"
            />
          </Col>
          <Col span={4}>
            <StatCard
              title="Nb. châssis en taux 3"
              value={'N/A'}
              variant="error"
              width="90%"
              height="126px"
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 40 }} justify="space-between">
          <Col style={{ width: '59%' }}>
            <Row className="d-flex justify-between align-center mb-2">
              <Col>
                <Title
                  comcode="latestRegChassis"
                  level={3}
                  className="font-familly-sans-serif mb-0"
                />
              </Col>
              <Col>
                <Row justify="end">
                  <ButtonLink comcode=">5 jours" className="btn-dashboard" />
                  <ButtonLink comcode="5 jours" className="btn-dashboard" />
                  <ButtonLink comcode="4 jours" className="btn-dashboard" />
                  <Col
                    className="text-right"
                    style={{
                      marginLeft: 10,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <p className="d-flex align-items-center font-size-15 pt-1 pl-3 pr-3">
                      {' '}
                      <GetLabel label="seeAll" />
                      <ArrowRightOutlined className="color-orange ml-2" />
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col style={{ width: '38.5%' }} className="d-flex align-center">
            <p className="font-size-18 font-weight-500 d-flex align-center">
              <GetLabel label="ConsumedLimits" />
              <ArrowRightOutlined className="color-orange ml-5" />
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }} justify="space-between">
          <Col
            style={{ width: '59%' }}
            className="no-border-radius no-padding "
          >
            <Card bordered={false} style={{ padding: 0 }}>
              <DataGrid
                dataSource={[]}
                columns={columns}
                rowKey={''}
                scroll={{ x: 1000, y: 360 }}
                pagination={{ pageSize: 10 }}
                hideFilters
                hideTitle
              />
            </Card>
          </Col>
          <Col style={{ width: '38.5%' }} className="no-border-radius">
            <Card className="pl-6 pr-6">
              <Row
                justify="space-between"
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  gap: 34,
                }}
              >
                {/* to be changed to antd progress component  */}
                {/* <DualPieChart
                  width={190}
                  height={190}
                  percentageValue={40}
                  darkColor="#3B55B9"
                  lightColor="#3B55B91A"
                  label="VN"
                />
                <DualPieChart
                  width={190}
                  height={190}
                  percentageValue={75}
                  darkColor="#3B55B9"
                  lightColor="#3B55B91A"
                  label="VO"
                />
                <DualPieChart
                  width={190}
                  height={190}
                  percentageValue={60}
                  darkColor=" #3B55B9"
                  lightColor="#3B55B91A"
                  label="DEMO"
                  heightStyle="137%"
                /> */}
                <div className="flex flex-col items-center">
                  <ProgressBarChart
                    percentageValue={0}
                    width={145}
                    height={145}
                    label="VN"
                  />
                </div>
                <div className="flex flex-col items-center">
                  <ProgressBarChart
                    percentageValue={0}
                    width={145}
                    height={145}
                    label="VO"
                    />
                </div>
                <div className="flex flex-col items-center">
                  <ProgressBarChart
                    percentageValue={0}
                    width={145}
                    height={145}
                    label="DEMO"
                  />
                </div>
                {/* end of change here */}
                {/* <DualPieChart
                  width={190}
                  height={190}
                  percentageValue={60}
                  darkColor="#3B55B9"
                  lightColor="#3B55B91A"
                  label="DEMO"

                {/* end of change here */}
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Dashboard;
